const MixCodeQueryFields = [
    {
        name: '#',
        code: '_seq_',
        column: true,
        sortable: false,
        defaultFilter: false,
        width: 60
    },
    {
        name: 'Factory',
        code: 'factoryName',
        column: true,
        sortable: true,
        align: 'center',
        defaultFilter: true,
        listFilter: true,
        width: 150
    },
    {
        name: 'Po',
        code: 'po',
        column: true,
        sortable: true,
        align: 'center',
        defaultFilter: true,
        listFilter: true,
        width: 150
    },
    {
        name: 'Style',
        code: 'style',
        column: true,
        sortable: true,
        defaultFilter: true,
        listFilter: true,
        align: 'center',
        width: 150
    },
    {
        name: 'Color',
        code: 'color',
        column: true,
        defaultFilter: false,
        listFilter: false,
        sortable: true,
        align: 'center',
        width: 100
    },
    {
        name: 'Size',
        code: 'size',
        column: true,
        defaultFilter: false,
        listFilter: false,
        sortable: true,
        align: 'center',
        width: 150
    },
    {
        name: 'Barcode',
        code: 'barcode',
        column: true,
        sortable: true,
        align: 'left',
        width: 100
    },
    {
        name: 'Quantity',
        code: 'quantity',
        column: true,
        sortable: true,
        align: 'left',
        width: 100
    }
];
export default MixCodeQueryFields;
